module.exports = __webpack_public_path__ + "img/mullins-island-city.e5922247.jpg";